<template>
    <div :class="classes">
        <img v-bind:src="iconSource"  alt="" class="icon opacity" :style="{ 'width': sizeWidth, 'height': sizeHeight, 'opacity': opacity }">
    </div>
</template>

<script>
    export default {
        props: {
            url: String,
            path: String,
            name: String,
            extension: String,
            classes: String,
            sizeWidth: String,
            sizeHeight: String,
            opacity: String
        },
        computed:{
            iconSource(){
                return this.url ? `${this.url}/${this.name}.${this.extension}` : `/images/${this.path}/${this.name}.${this.extension}`;
            }
        }
    }
</script>

<style scoped lang="scss">
</style>
